import { useSearchParams } from 'react-router-dom';

export const useGetParams = () => {
  const [searchParams] = useSearchParams();
  let phoneNumber = searchParams.get('phoneNumber');

  if (phoneNumber) {
    let textNumber;
    textNumber = phoneNumber
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/"/g, '&quot;');
    if (textNumber[0].match(/\s/)) {
      textNumber = textNumber.replace(/\s/, '+');
    }
    phoneNumber = textNumber;
  }

  const getDefaultValue = (value, defaultValue) => {
    if (value === '0') {
      return '';
    } else if (value) {
      return value;
    } else return defaultValue;
  };

  return {
    user: searchParams.get('user') || '',
    bg: searchParams.get('bg') || null,
    bgColor: searchParams.get('bgColor') || 'rgba(0,0,0,0.0)',
    startFrom: parseInt(searchParams.get('startFrom') || '') || 2,
    repeatCount: parseInt(searchParams.get('repeatCount') || '') || 50000,
    speedSlow: searchParams.get('speedSlow')
      ? parseInt(searchParams.get('speedSlow') || '')
      : 500,
    speedFast: searchParams.get('speedFast')
      ? parseInt(searchParams.get('speedFast') || '')
      : 100,
    authorFontSize: searchParams.get('authorFontSize') || '4',
  };
};
